import { render } from "./SearchResults.vue?vue&type=template&id=4c734d25&scoped=true&ts=true"
import script from "./SearchResults.vue?vue&type=script&lang=ts"
export * from "./SearchResults.vue?vue&type=script&lang=ts"

import "./SearchResults.vue?vue&type=style&index=0&id=4c734d25&lang=scss&scoped=true"

import exportComponent from "C:\\BuildAgent\\work\\e394cd1ec4c7054f\\src\\TicketSolutions.Personalisation.Client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c734d25"]])

export default __exports__